<template>
  <el-select
    :value="tariffId"
    :size="size"
    placeholder="Выберите тариф"
    style="width: 100%"
    :loading="loading && !tariffs.length"
    @change="change"
  >
    <el-option
      v-for="tariff in allowedTariffs"
      :key="tariff.id_tariff"
      :label="tariff.name"
      :value="tariff.id_tariff"
    />
  </el-select>
</template>

<script>
import { ApiService } from "@/api";

export default {
  name: "SelectTariff",
  model: {
    prop: "tariff-id",
    event: "change",
  },
  props: {
    tariffId: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      loading: true,
      tariffs: [],
    };
  },
  computed: {
    allowedTariffs() {
      const deniedTariffs = [41];

      return this.tariffs.filter((tariff) => !deniedTariffs.includes(tariff.id_tariff));
    },
  },
  created() {
    ApiService.tariffs
      .getAvailableTariffs()
      .then((tariffs) => {
        this.tariffs = tariffs;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    change(id_tariff) {
      const selectedTariff = this.tariffs.find((t) => t.id_tariff === id_tariff);
      this.$emit("change", selectedTariff);
    },
  },
};
</script>
